import { useEffect } from 'react';

export default function PageTitle(props) {
  useEffect(function() {
    document.title = props.title ? props.title + ' | Andre M Leather' : 'Andre M Leather — Handcrafted Leather Bags';
  }, [props.title]);

  return null;
}